import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import logo from '../assets/images/logo.png'
import googleimage from '../assets/images/googleimage.png'

import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
  FaStore,
  FaHotel,
  FaUtensils,
  FaGlassCheers,
  FaCalendarAlt,
  FaDumbbell,
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcPaypal
} from 'react-icons/fa';
import paarbusiness from '../assets/images/paarbusiness.png'
import paardigital from '../assets/images/paardigital.png'
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { webDetails, serviceCategory } from '../api/api';
import { Link } from 'react-router';

function Terms() {
  const [sticky, setSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const [webData, setWebData] = useState(null);
  const [servCat, serviCateg] = useState(null);

  useEffect(() => {
    webDetails()
      .then((res) => {
        setWebData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    serviceCategory()
      .then((res) => {
        serviCateg(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // const categories = [
  //   { name: "Shops", icon: <FaStore />, url: "/category/shops" },
  //   { name: "Hotels", icon: <FaHotel />, url: "/category/hotels" },
  //   { name: "Restaurants", icon: <FaUtensils />, url: "/category/restaurants" },
  //   { name: "Bars", icon: <FaGlassCheers />, url: "/category/bars" },
  //   { name: "Events", icon: <FaCalendarAlt />, url: "/category/events" },
  //   { name: "Fitness", icon: <FaDumbbell />, url: "/category/fitness" }
  // ];

  const socialLinks = [
    { icon: <FaFacebookF />, url: webData?.faceBook, color: "#1877f2" },
    { icon: <FaTwitter />, url: webData?.twitter, color: "#1da1f2" },
    { icon: <FaInstagram />, url: webData?.instagram, color: "#e4405f" },
    { icon: <FaTiktok />, url: webData?.youtube, color: "#000000" },
    // { icon: <FaWhatsapp />, url: webData?.print, color: "#25d366" }
    {
      icon: <FaWhatsapp />,
      url: webData?.phone ? `https://wa.me/91${webData.phone}` : null,
      color: "#25d366"
    }
  ];

  const paymentIcons = [
    { icon: <FaCcVisa />, name: "Visa" },
    { icon: <FaCcMastercard />, name: "Mastercard" },
    { icon: <FaCcAmex />, name: "American Express" },
    { icon: <FaCcPaypal />, name: "PayPal" }
  ];

  const year = new Date().getFullYear();
  return (
    <>
      <header className={`simple-header ${sticky ? "simple-header--sticky" : ""}`}>
        <div className="container">
          <div className="simple-header__container">
            {/* Logo */}
            <div className="simple-header__logo">
              <NavLink to={'/'} title="Sparker - Directory and listings template">
                <img
                  src={logo}
                  alt="Logo"
                  className="simple-header__logo-img"
                />
              </NavLink>
            </div>

            {/* Desktop Navigation */}
            <nav className="simple-header__nav">
              <ul className="simple-header__nav-list">

                <li className="simple-header__nav-item">
                  <NavLink to="/contact" className="simple-header__nav-link">
                    Contact Us
                  </NavLink>
                </li>
                {/* <li className="simple-header__nav-item">
                  <NavLink to="/terms" className="simple-header__nav-link">
                    Terms and conditions
                  </NavLink>
                </li> */}
                <li className="simple-header__nav-item">
                  <NavLink to="/privacy" className="simple-header__nav-link">
                    Privacy Policy
                  </NavLink>
                </li>
              </ul>
            </nav>

            {/* Google Play Store Button */}
            {/* <div className="simple-header__actions">
                        <a
                            href="https://play.google.com/store/apps"
                            className="simple-header__playstore-btn"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={googleimage} alt="googleimage" />
                        </a>
                    </div> */}
            {/* <div className="d-flex gap-2 headerqr">
              <div className="qrimageall">
                <img src={paarbusiness} alt="paarbusiness" />
              </div>
              <div className="qrimageall">
                <img src={paardigital} alt="paardigital" />
              </div>
            </div> */}

            {/* Mobile Menu Button */}
            <button
              className="simple-header__mobile-btn"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span className={`simple-header__hamburger ${menuOpen ? "simple-header__hamburger--active" : ""}`}>
                <span className="simple-header__hamburger-line"></span>
                <span className="simple-header__hamburger-line"></span>
                <span className="simple-header__hamburger-line"></span>
              </span>
            </button>

            {/* Mobile Navigation Overlay */}
            <div
              className={`simple-header__mobile-overlay ${menuOpen ? "simple-header__mobile-overlay--active" : ""}`}
              onClick={() => setMenuOpen(false)}
            ></div>

            {/* Mobile Navigation Menu */}
            <nav className={`simple-header__mobile-nav ${menuOpen ? "simple-header__mobile-nav--active" : ""}`}>
              <div className="d-flex justify-content-between p-2">
                <div className="simple-header__mobile-header">
                  <img src={logo} alt="Logo" />
                </div>
                <button
                  className="simple-header__mobile-close"
                  onClick={() => setMenuOpen(false)}
                >
                  ✕
                </button>
              </div>
              <ul className="simple-header__mobile-nav-list">
                <li className="simple-header__mobile-nav-item">
                  <a href="/contact" className="simple-header__mobile-nav-link" onClick={() => setMenuOpen(false)}>Contact Us</a>
                </li>
                {/* <li className="simple-header__mobile-nav-item">
                  <a href="/terms" className="simple-header__mobile-nav-link" onClick={() => setMenuOpen(false)}>Terms and conditions</a>
                </li> */}
                <li className="simple-header__mobile-nav-item">
                  <a href="/privacy" className="simple-header__mobile-nav-link" onClick={() => setMenuOpen(false)}>Privacy Policy</a>
                </li>
                <li className="simple-header__mobile-nav-item">
                  <a
                    href="https://play.google.com/store/apps"
                    className="simple-header__mobile-playstore-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setMenuOpen(false)}
                  >
                    <img src={googleimage} alt="googleimage" />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>      
      <div className='container'>
        <div className="terms_condition privacy-policy">
          <h1> Terms of Use</h1>

          <h3>1. Interpretation and Definitions</h3>
          <p>The following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or plural.</p>

          <h3>Definitions: For the purposes of these Terms and Conditions:</h3>
          <ul>
            <li><span>I. Country</span> refers to the Republic of India.</li>
            <li><span>II. Company</span> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Paar Digital Service.</li>
            <li><span>III. Device</span> means any device that can access the Service such as a computer, a cell phone or a digital tablet.</li>
            <li><span>IV. Service</span> refers to the Website.</li>
            <li><span>V. Terms and Conditions</span> (also referred to as "Terms") mean these Terms and Conditions that form the entire agreement between You and the Company regarding the use of the Service.</li>
            <li><span>VI. Third-party Social Media Service</span> means any services or content (including data, information, products or services) provided by a third-party that may be displayed, included or made available by the Service.</li>
            <li><span>VII. Website</span> refers to https://paardigitalservice.com/ accessible from Paar app/browser.</li>
            <li><span>VIII. You</span> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
          </ul>

          <h3>2. ACKNOWLEDGEMENT</h3>
          <p>These are the Terms and Conditions governing the use of this Service and the agreement that operates between you and the Company. These Terms and Conditions set out the rights and obligations of all users regarding the use of the Service.</p>
          <p>Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms and Conditions. These Terms and Conditions apply to all visitors, users, and others who access or use the Service. By accessing or using the Service, You agree to be bound by these Terms and Conditions. If you disagree with any part of these Terms and Conditions, then you may not access the Service.</p>
          <p>Your access to and use of the Service is also conditioned on your acceptance of and compliance with the Privacy Policy of the Company. Our Privacy Policy describes our policies and procedures on the collection, use, and disclosure of your personal information.</p>
          <p>The Paar website/app is an internet-based on-demand auto care technologies company owned and operated by Paar Digital Service having its registered office at Paar Digital Service, Ajmer, Rajasthan, India.</p>
          <p>Through the Paar mobile application, Paar Digital Service shall provide you (“user”) services-related information, pricing, availability, and booking for the daily car grooming, car washing, car servicing (“service”). This service may be availed by the registered users. This user agreement sets out the terms and conditions on which Paar Digital Service shall provide the services to the users through the Paar application. These terms and condition may be updated or modified by Paar from time to time.</p>
          <p>Please read these terms and conditions (“Terms and Conditions”) carefully before using Paar website and the Paar mobile application operated by Paar Digital Service. Your access to and use of the service is conditioned on your acceptance of and compliance with these terms. These terms apply to all visitors, users, partners, and others who access or use the service. By accessing or using the service, you agree to be bound by these terms. If you disagree with any part of the terms, then you may not access the service.</p>




          <h3>3. REFUND POLICY</h3>
          <p>Paar shall not be liable for any delays or failures in performance resulting from acts beyond its reasonable control including, without limitation, acts of god, terrorism, pandemic, or epidemic, shortage of supply, breakdowns, or malfunctions. Considering the act of god events, you have the option either to reschedule the session or you will be entitled to obtain a refund. All the referral income or credits given by Paar can be only used on Paar app and for its services. You can request for Service cancellation through Paar app and all the refunds will be processed to you through Paar app only. All the refunds will be initiated during 7 to 15 business days. In any worse case, which is not mentioned in the agreement, Paar will only take liability of the service amount only.</p>

          <h3>4. APPLICABLE LAWS</h3>
          <p>These terms and conditions will be subject to the laws of India, and the courts shall have jurisdiction to resolve any dispute between us.</p>

          <h3>5. PRICING AND PAYMENT TERMS</h3>
          <p>All the prices of the product may vary from city to city and type of the service and delivery slot taken by the customer. All the pricing decisions are in the hands of Paar Digital Service and it is binding on the customers. While delivering the product, if any malfunction happens to vehicles, then Paar won’t be responsible. Note: Services regarding cleaning of vehicles or completion time can vary according to the work of service; it depends on how dirty the vehicle is.</p>



          <h3>6. CANCELLATION OF BOOKINGS</h3>
          <p>The details regarding the variety of services are visible to the customers on the Paar app/website, and you can book the required services through the Paar app. If the service is cancelled by the user for any reason whatsoever, a cancellation charge of 100 Rs is applied as a penalty. If the service is cancelled by Paar for any reason whatsoever, the user shall be given a refund or rebate as required. Paar reserves all the rights to cancel or restrict any bookings subject to availability. In the case of postponing any service for whatever reason, Paar Digital Service has all the rights to charge additional costs to the customer. (The amount charged will be completely in the hands of Paar Digital Service.) Paar can postpone the service any time according to the supply side of availability, and the postponement of service can happen only for the selected time by the customer. If the selected slot is available, Paar can reschedule the specific slot, but all rescheduled slot decisions are in the hands of Paar. In case of any unavailability of any service by Paar, Paar will give a refund for the specific service. All the refund decisions are completely in the hands of Paar Digital Service.</p>

          <h3>7. LINKS TO OTHER WEBSITES</h3>
          <p>Our Service may contain links to third-party websites or services that are not owned or controlled by Paar Digital Service. Paar Digital Service has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You further acknowledge and agree that the Company shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services. We strongly advise you to read the terms and conditions and privacy policies of any third-party websites or services that you visit.</p>

          <h3>8. CHANGES TO THESE TERMS AND CONDITIONS</h3>
          <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will make reasonable efforts to provide notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion. By continuing to access or use Our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, in whole or in part, please stop using the website and the Service.</p>
          <h3>9. INTENTION</h3>
          <p>Paar Digital Service has an intention to establish a long-term business relationship with its service partners. The company intends to empower its selective leaders and wishes them to reach the peak of success, where service partners can expand the business by connecting cleaners to provide good-quality services to its customers. In case of loss of any valuables, it should be the responsibility of the end customer to take care of their respective belongings. In case of any malfunction or loss, Paar Digital Service has no responsibility and is not liable for any loss or recovery.</p>

          <h3>10. RESERVATION OF RIGHTS</h3>
          <p>Any rights not expressly granted in these Website Terms are reserved.</p>

          <h3>11. PAYMENTS</h3>
          <p>The customer can pay by using credit card/debit card, net banking, and/or any other payment facilities provided by our third-party payment processing partner. We use a third-party provider to process payments for orders made on our website/app. The processing of your payment will be directly between you and the third-party payment service provider. We will be providing personal information, and it is your responsibility to read these terms and ensure that you understand and agree to be bound by them. The customer acknowledges and agrees that we shall have no liability in case of any dispute between the customer and such third-party service provider. The customer will receive all the information regarding payment through email.</p>

          <h3>12. ACCEPTANCE OF TERM</h3>
          <p>The Website can only be used by a person who can form legally binding contracts under applicable law. The Website cannot be accessed by a person whose registration has been suspended or terminated by the Company for any reason whatsoever. You represent that you have the legal authority to accept these Website “Terms of Use” on behalf of yourself or any party you represent. Use of the Website is unauthorized in any jurisdiction that does not give effect to the Website “Terms of Use”.</p>


          <h3>13. LIABILITY</h3>
          <p>You agree to indemnify us against any losses, damages, and claims (and all related costs) incurred by or made against us by an Operator or any other third party arising out of or in connection with any Reviews or other Visitor Data that you provide in breach of any of the representations and warranties, agreements or restrictions set forth in this paragraph.</p>

          <h3>14. DISCLOSURE TO AUTHORITIES AND COURTS</h3>
          <p>You acknowledge that we will fully co-operate with any competent authority requesting or directing us to disclose the identity or location of anyone posting any Reviews or other Visitor Material in breach. Furthermore, you release us to the fullest extent permitted by law from all liability in relation to such disclosure.</p>

          <h3>15. TERMINATION</h3>
          <p>Grounds for termination: We may terminate or suspend (at our absolute discretion) your right to use the Platform and the Service immediately by notifying you through email if we believe in our sole discretion that:</p>
          <ul>
            <li>You have used the Website in breach of our permitted terms of use.</li>
            <li>You have posted Reviews or other Visitor Material in breach of the Visitor Material Policy.</li>
            <li>You have breached any other material terms of these Website Terms.</li>
          </ul>

          <h3>16. SEVERABILITY</h3>
          <p>If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law, and the remaining provisions will continue in full force and effect.</p>

          <h3>17. LIMITATION ON TIME TO INITIATE DISPUTE</h3>
          <p>Any action or proceeding by you relating to any dispute must commence within one year after the cause of action arises unless stated otherwise under the applicable law.</p>

          <h3>18. DISCLAIMER OF WARRANTY</h3>
          <p>Company does not warrant or make any representations regarding the use, validity, accuracy, or reliability of, or the results of the use of, or otherwise respecting, the content of the Website or any other websites linked to or from the Website. The content of the Website is provided "as is" without warranties of any kind, either express or implied. To the fullest extent possible pursuant to applicable law, Company disclaims all warranties, express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement, or other violation of third-party rights revisions. Company may revise or withdraw the content, in whole or in part, at any time without notice.</p>

          <h3>19. CONTACT US</h3>
          <p>If you have any questions about these terms, please contact us at sales@paardigitalservice.com.</p>

        </div>
      </div>
      <footer className="app-footer">

        <div className="container footer-container">
          <div className="row g-4">

            {/* About */}
            <div className="col-lg-6 col-md-6 col-sm-6">
              <h3 className="footer-title">About Us</h3>

              <p>
                {webData?.aboutUsLong || "Loading..."}
              </p>

              <div className="social-section">
                <h5>Follow Us</h5>
                <div className="social-links">
                  {socialLinks.map((social, index) => (
                    social.url && (
                      <a
                        key={index}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        style={{ '--social-color': social.color }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = social.color;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                        }}
                      >
                        {social.icon}
                      </a>
                    )
                  ))}
                </div>
              </div>
            </div>

            {/* Categories */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <h3 className="footer-title">Categories</h3>
              <ul className="footer-links">
                {servCat && servCat.map((cat) => (
                  <li key={cat._id}>
                    <a href="#">
                      {cat.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <h3 className="footer-title">Contacts</h3>

              <div className="contact-item">
                <MdLocationOn />
                <span>{webData?.address || "Loading..."}</span>
              </div>

              <div className="contact-item">
                <MdPhone />
                {webData?.phone && (
                  <a href={`tel:+91${webData.phone}`}>
                    +91 {webData.phone}
                  </a>
                )}
              </div>

              <div className="contact-item">
                <MdEmail />
                {webData?.email && (
                  <a href={`mailto:${webData.email}`}>
                    {webData.email}
                  </a>
                )}
              </div>
              {/* <div className="d-flex footer_qr">
                <div className="qrimageall">
                  <img src={paarbusiness} alt="paarbusiness" />
                </div>
                <div className="qrimageall">
                  <img src={paardigital} alt="paardigital" />
                </div>
              </div> */}
            </div>

          </div>

          <hr className="footer-divider" />

          <div className="row align-items-center footer-bottom">
            <div className="col-lg-6">
              <div className="selector-group">
                {/* Payment Icons */}
                <div className="payment-icons">
                  {paymentIcons.map((payment, index) => (
                    <span key={index} title={payment.name}>
                      {payment.icon}
                    </span>
                  ))}
                </div>
              </div>
            </div>


            <div className="col-lg-6">
              <ul className="footer-links-bottom">
                <li><Link to={"/contact"}>Contact Us</Link></li>
                {/* <li><Link to={"/terms"}>Terms and conditions</Link></li> */}
                <li><Link to={"/privacy"}>Privacy Policy</Link></li>
                <li>
                  <span className='text-white'>
                    © {year}. All rights reserved
                  </span>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </footer>
    </>
  );
}

export default Terms;
